import getEnv from "./getEnv";
import { Environ } from "./types";

export const redirectToAuthorise = (redirectUri: string) => {
  const sameSite = getEnv() === Environ.LOCAL ? "lax" : "strict";
  const nonce = window.crypto.randomUUID();
  document.cookie = `${nonce}=${window.location.pathname}${window.location.search}; path=/; secure; sameSite=${sameSite}; max-age=3600`;
  window.location.href = `${redirectUri}&state=${nonce}`;
};
